import React, { useState, useEffect, useCallback } from "react";
import "./ImageGallery.css";

const ImageGallery = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const images = [
    {
      src: require("../../../images/people/events/womens-day-celebration.jpg"),
      alt: "Women's Day celebration group at Alisar Prospects Training",
      caption: "Women's Day Celebration",
    },
    {
      src: require("../../../images/people/training/workshop-empowerment-group.png"),
      alt: "Community empowerment workshop participants",
      caption: "Community Empowerment Workshop",
    },
    {
      src: require("../../../images/people/events/thank-you-board.jpg"),
      alt: "Community members at APT event",
      caption: "Community Event",
    },
    {
      src: require("../../../images/people/training/training-session-1.jpg"),
      alt: "APT training session",
      caption: "Training Session",
    },
    {
      src: require("../../../images/people/training/workshop-collaboration.jpg"),
      alt: "Workshop participants collaborating",
      caption: "Collaborative Workshop",
    },
  ];

  const nextImage = useCallback(() => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
  }, [images.length]);

  useEffect(() => {
    const interval = setInterval(nextImage, 6000);
    return () => clearInterval(interval);
  }, [nextImage]);

  return (
    <section className="image-gallery-section">
      <div className="image-gallery-header">
        <h2>Our Community in Action</h2>
        <p>
          A closer look at the people, partnerships, and practical outcomes that
          shape our work.
        </p>
      </div>

      <div className="community-gallery-layout">
        <div className="gallery-stage">
          <div className="main-image-container">
            <img
              src={images[activeIndex].src}
              alt={images[activeIndex].alt}
              className="main-gallery-image"
              loading="lazy"
            />
            <div className="image-caption-wrap">
              <p className="image-caption">{images[activeIndex].caption}</p>
              <p className="image-counter">
                {activeIndex + 1} / {images.length}
              </p>
            </div>
          </div>
        </div>

        <aside className="gallery-story-list" aria-label="Gallery moments">
          <h3>Moments from our programmes</h3>
          {images.map((image, index) => (
            <button
              key={index}
              type="button"
              className={`story-item ${index === activeIndex ? "active" : ""}`}
              onClick={() => setActiveIndex(index)}
              aria-label={`View ${image.caption}`}
            >
              <span className="story-item-index">{index + 1}</span>
              <span className="story-item-content">
                <span className="story-item-title">{image.caption}</span>
                <span className="story-item-subtitle">View moment</span>
              </span>
            </button>
          ))}
        </aside>
      </div>

      <div className="gallery-stats-bar">
        <div className="gallery-stat">
          <span className="stat-number">750+</span>
          <span className="stat-text">Community Members</span>
        </div>
        <div className="gallery-stat">
          <span className="stat-number">5</span>
          <span className="stat-text">London Boroughs</span>
        </div>
        <div className="gallery-stat">
          <span className="stat-number">12+</span>
          <span className="stat-text">Years Serving Communities</span>
        </div>
      </div>
    </section>
  );
};

export default ImageGallery;
